import gameCollectionBgDefault01 from './gameCollectionBgDefault01.png'
import gameCollectionHeadingBgDefault01 from './gameCollectionHeadingBgDefault01.png'
import gameCollectionShelfRowDefault01 from './gameCollectionShelfRowDefault01.png'

export const gameCollectionHeadingBgMap: Record<string, string> = {
  gameCollectionHeadingBgDefault01,
}

export const gameCollectionBgMap: Record<string, string> = {
  gameCollectionBgDefault01,
}

export const gameCollectionShelfRowMap: Record<string, string> = {
  gameCollectionShelfRowDefault01,
}

export function getTemplate(map: Record<string, string>, templateName: string): string {
  return map[templateName] || ''
}
